// Camp Jain Animations with ScrollMagic and GSAP
class CampJainAnimations {
  constructor() {
    this.controller = null;
    this.init();
  }

  async init() {
    // Éviter la double initialisation
    if (window.campAnimationsInitialized) {
      return;
    }

    // Vérifier si ScrollMagic et GSAP sont chargés
    if (typeof ScrollMagic === 'undefined' || typeof gsap === 'undefined') {

      return;
    }

    this.controller = new ScrollMagic.Controller();

    window.campAnimationsInitialized = true;

    // Ajouter une classe pour indiquer que les animations sont prêtes
    document.body.classList.add('camp-animations-ready');

    this.setupAnimations();
  }

  setupAnimations() {
    // Effet parallax sur les images
    this.parallaxImages();

    // Effet parallax sur les textes
    this.parallaxTexts();

    // Animation des grilles d'images
    this.animateImageGrids();

    // Micro-animations de flottement
    // this.addFloatingEffects();
  }

  parallaxImages() {
    const images = document.querySelectorAll('.parallax-img');

    images.forEach(img => {
      // Générer des décalages aléatoires entre 30% et -30%
      const startY = 30 + Math.random() * 20; // Entre 30% et 45%
      const endY = -30 - Math.random() * 20;   // Entre -20% et -30%

      const scene = new ScrollMagic.Scene({
        triggerElement: img.parentElement,
        triggerHook: 1,
        duration: "200%"
      })
        .setTween(gsap.fromTo(img, {
          y: startY + "%"
        }, {
          y: endY + "%",
          ease: "none"
        }))
        .addTo(this.controller);
    });
  }

  parallaxTexts() {
    const texts = document.querySelectorAll('.camp-block__content');

    texts.forEach(text => {
      const scene = new ScrollMagic.Scene({
        triggerElement: text.parentElement,
        triggerHook: 1,
        duration: "200%"
      })
        .setTween(gsap.fromTo(text, {
          y: "20%"
        }, {
          y: "-20%",
          ease: "none"
        }))
        .addTo(this.controller);
    });
  }

  animateImageGrids() {
    // Section 2 - Photos en pêle-mêle
    this.animatePhotos();

    // Section 4 - Affiches en pêle-mêle
    this.animateAffiches();

    // Section 6 - Polaroids en pêle-mêle
    this.animatePolaroids();
  }

  animatePhotos() {
    const photosSection = document.querySelector('.camp-block__section2');
    if (!photosSection) {
      return;
    }

    const photos = photosSection.querySelectorAll('img');

    photos.forEach((photo, index) => {
      // Alternance droite/gauche : les images paires viennent de droite, impaires de gauche
      const fromRight = index % 2 !== 0;
      const startX = fromRight ? '100vw' : '-100vw'; // Partir de très loin hors écran

      gsap.set(photo, {
        opacity: 0,
        x: startX,
        scale: 0.3
      });
    });

    const scene = new ScrollMagic.Scene({
      triggerElement: photosSection,
      triggerHook: 0.7,
      reverse: false
    })
      .setTween(gsap.to(photos, {
        duration: 0.6,
        opacity: 1,
        x: 0, // Revenir à leur position CSS absolue
        scale: 1,
        ease: "back.out(1)",
        stagger: {
          amount: 0.4, // Délai total entre toutes les images réduit
          each: 0.1    // Délai entre chaque image réduit
        }
      }))
      .addTo(this.controller);
  }

  animateAffiches() {
    const affichesGrid = document.querySelector('.camp-block__section4 .camp-block__images');
    if (!affichesGrid) return;

    const affiches = affichesGrid.querySelectorAll('img');

    affiches.forEach((affiche, index) => {
      const defaultRotation = parseFloat(affiche.getAttribute('data-rotate')) || 0;

      gsap.set(affiche, {
        opacity: 0,
        y: '300px',
        rotation: (Math.random() - 0.5) * 20,
        scale: 0.3
      });

      // Stocker la rotation par défaut comme attribut de données
      affiche.dataset.defaultRotation = defaultRotation;
    });

    const scene = new ScrollMagic.Scene({
      triggerElement: affichesGrid,
      triggerHook: 0.6,
      reverse: false
    })
      .setTween(gsap.to(affiches, {
        duration: 0.85, // Animation plus rapide
        opacity: 1,
        y: 0, // Revenir à la position CSS
        rotation: (index, target) => parseFloat(target.dataset.defaultRotation) || 0,
        scale: 1,
        ease: "back.out(1)",
        stagger: {
          amount: 0.25, // Délai total réduit
          each: 0.06    // Délai entre chaque image réduit
        }
      }))
      .addTo(this.controller);
  }

  animatePolaroids() {
    const polaroidsGrid = document.querySelector('.camp-block__section6 .camp-block__images');
    if (!polaroidsGrid) return;

    const polaroids = polaroidsGrid.querySelectorAll('img');

    polaroids.forEach((polaroid, index) => {
      const defaultRotation = parseFloat(polaroid.getAttribute('data-rotate')) || 0;

      gsap.set(polaroid, {
        opacity: 0,
        y: '200px',
        rotation: (Math.random() - 0.5) * 30,
        scale: 0.4
      });

      // Stocker la rotation par défaut
      polaroid.dataset.defaultRotation = defaultRotation;
    });

    const scene = new ScrollMagic.Scene({
      triggerElement: polaroidsGrid,
      triggerHook: 0.6,
      reverse: false
    })
      .setTween(gsap.to(polaroids, {
        duration: 0.7,
        opacity: 1,
        y: 0,
        rotation: (index, target) => parseFloat(target.dataset.defaultRotation) || 0,
        scale: 1,
        ease: "back.out(1)",
        stagger: {
          amount: 0.3,
          each: 0.08
        }
      }))
      .addTo(this.controller);
  }
}

// Fonction d'initialisation
function initAnimations() {
  // Vérifier si les éléments existent
  const campBlock = document.querySelector('.camp-block');

  if (campBlock) {
    new CampJainAnimations();
  } else {
    setTimeout(initAnimations, 1000);
  }
}

// Initialiser les animations selon l'état du DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAnimations();
  });
} else {
  initAnimations();
}

// Backup - essayer aussi avec window.onload
window.addEventListener('load', () => {
  initAnimations();
});

// Exporter pour utilisation globale
window.CampJainAnimations = CampJainAnimations;